import React from 'react'
import { LocalTimeAgo } from 'shared'

type CommentProps = {
  image: string
  confirmedAt: number
  text: React.ReactNode | string
  title: string
}

export const Comment = ({ image: imageSrc, confirmedAt, text, title }: CommentProps) => (
  <div className="me-comment">
    <div className="flex">
      <img src={imageSrc} />

      <div className="me-comment-title mt-1">
        <span className="me-comment-title-first-line">{title}</span>
        <br />
        <span className="me-comment-title-second-line">
          <LocalTimeAgo timestamp={confirmedAt} />
        </span>
      </div>
    </div>

    {text && <div className="me-comment-text">{text}</div>}
  </div>
)
